import { DeleteOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Space } from 'antd';

interface BlogBulkActionsProps {
  selectedCount: number;
  loading: boolean;
  onBulkDelete: () => void;
  onClearSelection: () => void;
}

export const BlogBulkActions = ({
  selectedCount,
  loading,
  onBulkDelete,
  onClearSelection,
}: BlogBulkActionsProps) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 mb-4">
      <Space>
        <span className="text-sm text-blue-700">{selectedCount} selected</span>
        <Popconfirm
          title="Delete selected posts?"
          description="This will soft-delete the selected blog posts."
          onConfirm={onBulkDelete}
          okText="Delete"
          cancelText="Cancel"
          okButtonProps={{ danger: true }}
        >
          <Button danger icon={<DeleteOutlined />} loading={loading}>
            Delete Selected
          </Button>
        </Popconfirm>
        <Button type="link" onClick={onClearSelection}>
          Clear selection
        </Button>
      </Space>
    </div>
  );
};

export default BlogBulkActions;
